import React from 'react';

// Hoy for everyone except the owner: their commercial follow-up
// (Seguimiento de hoy), under the same first entry of the menu. The owner's
// Mi espacio is components/owner/OwnerSpace.jsx, which shows her day and the
// same follow-up on its Hoy tab (see src/navigation.js › resolvePage).

const muted = { fontSize: 13, color: 'var(--globant-muted)' };

// title/area: the same queue also opens as Comercial › Seguimientos (the owner's own entry, the same records)
export default function TodayHub({ children, title = 'Hoy', area = '' }) {
  const longDate = new Date().toLocaleDateString('es', { weekday: 'long', day: 'numeric', month: 'long' });
  const dateLabel = longDate.charAt(0).toUpperCase() + longDate.slice(1);
  return (
    <div className="page-content" style={{ padding: '24px 20px 48px', maxWidth: 1180, margin: '0 auto' }}>
      <header style={{ marginBottom: 16 }}>
        <div style={{ ...muted, fontSize: 14 }}>{area ? `${area} · ${dateLabel}` : dateLabel}</div>
        <h1 style={{ margin: '2px 0 0', fontSize: 28, fontWeight: 700, letterSpacing: '-0.4px' }}>{title}</h1>
      </header>
      <section aria-label="Seguimiento comercial">
        {children}
      </section>
    </div>
  );
}
